export const getTrainingIsCompleted = (
  lesson: LessonEntity,
  attendance?: AttendanceEntity,
  subscriberId?: number
) =>
  (!lesson.evidence_required &&
    (attendance?.lesson_status === 'viewed' ||
      attendance?.lesson_status === 'completed')) ||
  !!attendance?.evidence.filter((e) => e.created_by === subscriberId).length;
